/**
 *  Layout entity class
 */

/**
 * LayoutFactory
 * returns Layout entity class
 *
 * @class LayoutFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Layout} class
 *
 * @ngdoc factory
 * @name mwApp.factory:LayoutFactory
 */
/* @ngInject */
export default function LayoutFactory (Type, Entity) {
  /* === Layout class === */

  /**
   * Layout model
   *
   * @class Layout
   * @classdesc Layout model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.Layout} Layout entity
   */
  function Layout () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Layout.prototype = Object.create(Entity.prototype)
  Layout.prototype.constructor = Layout

  /* === Layout instance methods & fields === */

  Object.assign(Layout.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Layout#
     * @type {Object}
     */
    _fields: {
      id: Number,
      deviceType: String,
      menuItems: [{
        iconName: String,
        sortOrder: Number,
        title: String,
        items: [{
          iconName: String,
          moduleId: Number,
          sortOrder: Number,
          title: String
        }]
      }]
    },

    /**
     * url template
     *
     * @memberof models.Layout#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/appearance/layouts',

    /**
     * public url template
     *
     * @memberof models.Layout#
     * @type {String}
     */
    _publicUrlTemplate: 'organizations/{{::networkId}}/customization/modules/{{::id}}',

    /**
     * Prepare Accessory
     *
     * @memberof models.Layout#
     * @override
     */
    _prepare: function () {
    },
    /**
     * Get underlying object
     *
     * @memberof models.Layout#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      return Entity.prototype._object.apply(this, arguments)
    }

  })

  /* === Layout static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Layout, Entity)
  Layout._name = 'Layout'
  Layout.init()

  // permissions
  Layout.access = {
    view: 'viewSubscription createSubscriptionPayment |',
    create: 'createSubscription',
    edit: 'editSubscription',
    delete: 'deleteSubscription'
  }

  return Layout
}
